import useDetectPrint from 'conversations/evaluation-submission/hooks/useDetectPrint';
import { User } from 'generated/graphql';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import { Box, Flex } from 'reflexbox';

export default function AnswerLine({
	children,
	user,
	side,
}: {
	children: React.ReactNode;
	side: 'left' | 'right';
	user: User;
}) {
	const isPrinting = useDetectPrint();

	const leftMargin = side === 'right' ? 47 : 0;
	const rightMargin = side === 'left' ? 47 : 0;
	const direction = side === 'left' ? 'row' : 'row-reverse';

	return (
		<Flex
			flexGrow={1}
			flexDirection={isPrinting ? direction : ['column', direction]}
			mr={isPrinting ? rightMargin : [0, rightMargin]}
			ml={isPrinting ? leftMargin : [0, leftMargin]}
			mt={20}
			style={{ gap: 10 }}
		>
			<Flex
				flexShrink={0}
				flexGrow={0}
				flexDirection={'row'}
				alignItems={'center'}
				style={{ gap: '10px' }}
			>
				<PersonAvatar size={PersonAvatarSize.Medium} person={user} />
			</Flex>
			<Box flexGrow={1}>{children}</Box>
		</Flex>
	);
}
